module.exports = __webpack_public_path__ + "img/market_carnival_bottom@1x.84c5f155.png";